import React from "react";
import InfoIcon from '@mui/icons-material/Info';
import { Tooltip } from "@mui/material";
import QuizOutlinedIcon from '@mui/icons-material/QuizOutlined';

const ShipmentRate = ({ billed_rate = null, api_rate = null, is_multi_piece = null, is_voided = null }) => {
    let multi_piece = (is_multi_piece && is_multi_piece === true) ? true : false
    let voided = (is_voided && is_voided === true) ? true : false

    if (voided === true) {
        return <>-</>
    }

    // Helper function to check if the value is actually a valid number
    const isValidNumber = (val) => {
        return val !== null && val !== "" && val !== "-" && val !== "undefined" && !isNaN(val);
    };

    if (isValidNumber(billed_rate)) {
        return (
            <span>
                {parseFloat(billed_rate).toFixed(2)}
                {multi_piece === true &&
                    <Tooltip title="Multi piece shipment rate" placement="right-start">
                        <QuizOutlinedIcon color="warning" style={{ position: "relative", left: "5px", top: "5px" }} fontSize="small" />
                    </Tooltip>
                }
            </span>
        )
    } else if (isValidNumber(api_rate)) {
        return (
            <span>
                {parseFloat(api_rate).toFixed(2)}
                <Tooltip title="This is excluding tax and may change if there is any dimensional / weight adjustment" placement="right-start">
                    <InfoIcon style={{ position: "relative", left: "5px", top: "5px" }} fontSize="small" />
                </Tooltip>
                {multi_piece === true &&
                    <Tooltip title="Multi piece shipment rate" placement="right-start">
                        <QuizOutlinedIcon color="warning" style={{ position: "relative", left: "5px", top: "5px" }} fontSize="small" />
                    </Tooltip>
                }
            </span>
        )
    }
    else {
        return <>-</>
    }
}

export default ShipmentRate;